import { Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React, { SFC } from 'react'
import { TranslationFunction } from 'react-i18next'

import { i18nKeys } from '../../app.i18n'
import { identity } from '../../shared'
import { PaginationInfo } from '../smart-table'

import { PaginationButton } from './pagination-button'
import { PaginationSummary } from './pagination-summary'
import { createRenderedPaginationList } from './utils'

type Props = {
  pageInfo: PaginationInfo
  size?: 'sm' | 'lg'
  translate?: TranslationFunction
  onPageChange(page: number): void
}

const FIRST_PAGE = 1

const Pagination: SFC<Props> = ({ pageInfo, size, onPageChange, translate = identity }) => {
  const { numberOfPages: pages, actualPage: activePage } = pageInfo

  const LAST_PAGE = pages
  const paginationList = createRenderedPaginationList(activePage, pages)
  const isFirstPageActive = activePage === FIRST_PAGE
  const isLastPageActive = activePage === LAST_PAGE
  const previousPage = activePage === FIRST_PAGE ? FIRST_PAGE : activePage - 1
  const nextPage = activePage === LAST_PAGE ? LAST_PAGE : activePage + 1

  return (
    <div data-test="pagination">
      <PaginationButton
        data-test="first"
        page={FIRST_PAGE}
        disabled={isFirstPageActive}
        onClick={onPageChange}
        navigation
      >
        <Icon icon={IconNames.DOUBLE_CHEVRON_LEFT} title={false} />
        <span className="bp3-button-text">{translate(i18nKeys.shared.pagination.first)}</span>
      </PaginationButton>
      <PaginationButton
        data-test="previous"
        page={previousPage}
        disabled={isFirstPageActive}
        onClick={onPageChange}
        navigation
      >
        <Icon icon={IconNames.CHEVRON_LEFT} title={false} />
        <span className="bp3-button-text">{translate(i18nKeys.shared.pagination.previous)}</span>
      </PaginationButton>

      {paginationList.map((pageItem) => (
        <PaginationButton
          data-test="go-to-page"
          key={pageItem.page}
          page={pageItem.page}
          active={pageItem.active}
          onClick={onPageChange}
        >
          {pageItem.page}
        </PaginationButton>
      ))}

      <PaginationButton data-test="next" page={nextPage} disabled={isLastPageActive} onClick={onPageChange} navigation>
        <span className="bp3-button-text">{translate(i18nKeys.shared.pagination.next)}</span>
        <Icon icon={IconNames.CHEVRON_RIGHT} title={false} />
      </PaginationButton>
      <PaginationButton data-test="last" page={LAST_PAGE} disabled={isLastPageActive} onClick={onPageChange} navigation>
        <span className="bp3-button-text">{translate(i18nKeys.shared.pagination.last)}</span>
        <Icon icon={IconNames.DOUBLE_CHEVRON_RIGHT} title={false} />
      </PaginationButton>

      <PaginationSummary className="pagination__summary" translate={translate} {...pageInfo} />
    </div>
  )
}

export { Pagination }



// WEBPACK FOOTER //
// ./src/app/shared/pagination/pagination.tsx